var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dropdown-button", class: _vm.className }, [
    _c(
      "button",
      {
        staticClass: "dropdown-button__button",
        on: {
          click: function($event) {
            _vm.isOpen = !_vm.isOpen
          }
        }
      },
      [_vm._t("default"), _vm._v(" "), _vm._t("icon")],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isOpen,
            expression: "isOpen"
          }
        ],
        staticClass: "dropdown-button__content"
      },
      _vm._l(_vm.options, function(option) {
        return _c(
          "div",
          {
            key: option.value,
            staticClass: "content-item",
            on: {
              click: function($event) {
                return _vm.handleOptionClick(option)
              }
            }
          },
          [
            option.isSelected
              ? _c("span", { staticClass: "content-item__icon" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "16",
                        height: "16",
                        viewBox: "0 0 16 16",
                        fill: "none"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d:
                            "M13.8047 3.52864C14.0651 3.78899 14.0651 4.2111 13.8047 4.47145L6.4714 11.8048C6.21105 12.0651 5.78895 12.0651 5.5286 11.8048L2.19526 8.47145C1.93491 8.2111 1.93491 7.78899 2.19526 7.52864C2.45561 7.26829 2.87772 7.26829 3.13807 7.52864L6 10.3906L12.8619 3.52864C13.1223 3.26829 13.5444 3.26829 13.8047 3.52864Z",
                          fill: "#465669"
                        }
                      })
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v("\n      " + _vm._s(option.label) + "\n    ")
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }